import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IProjectDiscussionCommentContent } from '@shared/components/project-discussion/service/project-discussion.service.types';

@Component({
  selector: 'app-project-discussion-chat-header',
  templateUrl: './project-discussion-chat-header.component.html',
  styleUrls: ['./project-discussion-chat-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectDiscussionChatHeaderComponent {
  @Input() entry: IProjectDiscussionCommentContent;
}
